/**
 * En Route - Feed page
 */

import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";

const Feed = () => {
  return (
    <article>
      <Container>
        <Row>
          <h1>myFeed</h1>
        </Row>
      </Container>
    </article>
  );
};

export default Feed;
